ConcentratedPayoutsIndexHandler = {
  init: function() {
    $(document).on('click', '.expand-concentrated-payout', function(e) {
      e.preventDefault();
      var link = $(this);
      var concentratedPayoutId = link.data('id');
      var row = link.closest('tr');
      var existingDrillDown = row.next('.drill-down-row');

      if (existingDrillDown.length) {
        existingDrillDown.toggle();
        link.text(existingDrillDown.is(':visible') ? 'Collapse' : 'Expand');
        return;
      }

      link.text('Loading...');

      $.ajax({
        url: '/admin/concentrated_payouts/' + concentratedPayoutId + '/drill_down',
        method: 'GET',
        success: function(html) {
          var colSpan = row.find('td').length;
          var drillDownRow = $('<tr class="drill-down-row"><td colspan="' + colSpan + '">' + html + '</td></tr>');
          row.after(drillDownRow);
          link.text('Collapse');
        },
        error: function() {
          link.text('Expand');
          alert('Failed to load details');
        }
      });
    });
  }
};

ConcentratedPayoutsIndexHandler.init();
